import styled, { keyframes } from 'styled-components';

export const Content = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  border-radius: 6px;
  z-index: 2;
  pointer-events: ${(props) => (props.$active ? 'auto' : 'none')};
`;

/* soft breathing to match the card glow (no harsh blink) */
const softBlink = keyframes`
  0%, 100% { opacity: 0.7; }
  50% { opacity: 1; }
`;

/* calm corner marker on the icon (clear of the top barriers).
   The card glow already signals the state; this is a discrete,
   always-visible marker you can click to open the problem. */
export const Badge = styled.div`
  position: absolute;
  top: -13px;
  left: 50%;
  transform: translateX(-50%);
  width: 16px;
  height: 16px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  font-weight: 700;
  line-height: 1;
  color: #fff;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.45);
  border: 1px solid rgba(255, 255, 255, 0.25);
  animation: ${softBlink} 2.4s ease-in-out infinite;
  background: ${(props) => {
    switch (props.type) {
      case 'high':
        return '#d94141';
      case 'medium':
        return '#e0932f';
      case 'low':
      default:
        return '#d4a017';
    }
  }};
  &::before {
    content: '!';
  }
`;
